// ** React Imports
import { Outlet } from 'react-router-dom'

// ** Core Layout Import
// !Do not remove the Layout import
import Layout from '@layouts/VerticalLayout'

// ** Components
// import CustomNavbar from './components/Navbar'
// import CustomMenu from './components/Menu'
import CustomFooter from './components/Footer'

// ** Menu Items Array
import navigation from '@src/navigation/vertical'

const VerticalLayout = props => {
  // const [menuData, setMenuData] = useState([])

  // ** For ServerSide navigation
  // useEffect(() => {
  //   axios.get(URL).then(response => setMenuData(response.data))
  // }, [])

  return (
    <Layout
      menuData={navigation}
      // navbar={props => <CustomNavbar {...props} />} 
      // menu={props => <CustomMenu {...props} />}
      footer={<CustomFooter />}
      {...props}>
      <Outlet />
    </Layout>
  )
}

export default VerticalLayout
